import { render, staticRenderFns } from "./object-select-search.vue?vue&type=template&id=644f04d3&"
import script from "./object-select-search.vue?vue&type=script&lang=ts&"
export * from "./object-select-search.vue?vue&type=script&lang=ts&"
import style0 from "./object-select-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports